export default __webpack_public_path__ + "static/media/04-INT-(5-3).8b18004d.jpg";